import { cellToBoundary } from "h3-js";
import type { RadiusFeatureCollection } from "../../map/home-radius.js";

/** GeoJSON fill for an area warning's footprint: one closed polygon per covering cell,
 *  in [lng,lat] order (MapLibre). Mirrors home-radius.coneFeatureCollection but takes
 *  raw cell strings directly (no per-cell subject or confirmed metadata). */
export function footprintFC(cells: string[]): RadiusFeatureCollection {
  return {
    type: "FeatureCollection",
    features: cells.map((cell) => {
      const ring = cellToBoundary(cell, true) as number[][]; // [[lng,lat],...] open ring
      return {
        type: "Feature" as const,
        geometry: { type: "Polygon" as const, coordinates: [[...ring, ring[0]]] }, // close it
        properties: { cell },
      };
    }),
  };
}
